import React from 'react'
import ramsahu from './ramsahu.png'
import Services from './Services'

import Become from './Become'
import Plan from './Plan'
import Reward from './Reward'
import Count from './Count'
import Super from './Super'
import com1 from './com1.jpg'
import { Link } from 'react-router-dom'








const Common=(props) =>{
  return (
    <div>
      <>
      <section id='header' className='d-flex align-item-center mt-6'>
      <div className='container my-3'>
        <div className='row'>
          <div className='col-10-mx-auto'>
            <div className='row'>
            <div className='col-md-6 pt-5 pt-lg-0 order-2 order-lg-1 d-flex justify-content-center flex-column'>
              <h1>{props.name}<strong className='brand-name'>FUNDGUARD</strong></h1>
              <h2 className='my-3'>
               {props.name1}

              </h2>
              <div className='mt-3'>
                <Link to="/Services" className='btn btn-primary'>{props.getstarted}</Link>

              </div>

            </div>
            <div className='col-md-6 order-1 order-lg-2 header-img'>
              <img  src={props.imgUrl}className='img-fluid animated' alt=''/>

            </div>
            </div>
            <div className='container my-3 pt-4'>
            <div className="card mb-3" >
  <div className="row g-0">
    <div className="col-md-4">
      <img src={ramsahu} className="img-fluid rounded-start" alt="..."/>
    </div>
    <div className="col-md-8">
      <div className="card-body">
        <h5  className="card-title">{props.cardtittle}</h5>
        <p style={{color:'WindowText'}} className="card-text">{props.card}</p>
        <p className="card-text"><small className="text-muted">Last updated 3 mins ago</small></p>
      </div>
    </div>
  </div>
</div>

<div className='About'>
<div className='row'>
  <h1 style={{color:'WindowFrame'}}>About FundGuard</h1>
    <div className='col-md-12'>
        
        <p> I offer Insurance and other financial products to clients under my flagship company, FundGuard.

I have made a small attempt to setup my digital identity and accessible to my prospects and clients any time every time through digital media to provide accurate information & services they might require on their fingertips.

I am a licentiate from Insurance Regulatory and Development Authority (IRDA) and have been working as a customer focused Life Advisor & Financial Planner. I’m passionate to research the financial products and suggest the best suitable financial solution to my clients. I am an avid learner, apart from self study, I have been actively participating in industry seminars, trainings and forums to update my skills and mentor my fellow team members. It has helped me to develop a keen sense of foresight in financial domain to introduce revolutionary ways in insurance & financial products selling to suit the individual’s changing financial needs.</p>

    </div>
    </div>
</div>
<div className='insurance'>
    <div className='row'>
        <div className='col-md-8'>
            <h2>Insurance and Investment Services</h2>
            <p>We, FundGuard, offer a full range of Insurance and Investment Services like Life Insurance, Health Insurance, Motor Insurance, Personal Accident Insurance, Group Insurance, Travel Insurance, SIP (Systematic Investment Plan), Mutual Funds, Stocks, Commodities, Fixed Deposits etc. to our clients.

We are specialized in Retirement Planning, Risk Management, Investment Planning and Wealth Creation through a broad range of services that include Life Insurance, Mutual Funds, SIP & Health Insurance.</p>

        </div>
        <div className='col-md-4'>
            <img src={com1} alt=''/>

</div>


    </div>
   
</div>


</div>


          </div>
          <Become/>
          <Plan/>
          
          <Services/>
          <Reward/>
          <Count/>
         
          <Super/>
          
          

        </div>
        

      </div>


    </section>
   
    
      </>
    </div>
  )
}

export default Common
